var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-anexo clearfix" },
    [
      _c("p", { staticClass: "label" }, [
        _vm._v(_vm._s(_vm.documento.nome) + "  "),
        _c("i", { staticClass: "fal fa-file" })
      ]),
      _c(
        "el-button",
        {
          staticClass: "download-button",
          attrs: { type: "text" },
          on: {
            click: function($event) {
              return _vm.baixarDocumento(_vm.documento.id)
            }
          }
        },
        [_c("i", { staticClass: "fa fa-download" })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75b417b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75b417b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDownloadAnexo.vue
// module id = null
// module chunks = 